<template>
  <div class="ship-info">
    <div class="flex flex-col">
      <el-form ref="shipInfoForm" size="mini" label-position="top" :model="shipData" :inline="true" :rules="rules">
        <el-form-item label="IMO No." v-if="!isCustomer" prop="imo">
          <el-input size="mini" v-model="shipData.imo" :disabled="imoDisabled" clearable></el-input>
        </el-form-item>
        <el-form-item label="IMO No." v-if="isCustomer" prop="imo">
          <el-select v-model="shipData.imo" class="bargeNameinput" size="mini" placeholder="Search IMO" filterable
            remote :remote-method="handleSearchBarge" :loading="isBargeOptionsLoading" :disabled="imoDisabled"
            allow-create default-first-option @change="handleSelectedIMO" @input="onImoTyping">
            <el-option v-for="item in bargeoptions" :key="item.imo" :disabled="item.unFlag == 1"
              :label="item.bargeName ? `${item.imo} (${item.bargeName})` : item.imo" :value="item.imo" />
          </el-select>
        </el-form-item>
        <el-form-item label="Name" prop="shipName">
          <el-input size="mini" v-model="shipData.shipName" :disabled="shipInfoDisabled" clearable></el-input>
        </el-form-item>
        <el-form-item label="Built Date" prop="buildDate">
          <el-date-picker v-model="shipData.buildDate" placeholder="Built Date" type="date" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" :disabled="shipInfoDisabled" :picker-options="pickerOptions" clearable />
        </el-form-item>
        <el-form-item label="Dead Weight" prop="deadWeight">
          <el-input size="mini" v-model="shipData.deadWeight" type="number" :disabled="shipInfoDisabled"
            clearable></el-input>
        </el-form-item>
        <br v-if="this.$route.query.pageStatus == 2">
        <el-form-item label="Flag" prop="flag">
          <el-input size="mini" v-model="shipData.flag" :disabled="shipInfoDisabled" clearable></el-input>
        </el-form-item>
        <el-form-item label="Loa" prop="loa">
          <el-input size="mini" v-model="shipData.loa" :disabled="shipInfoDisabled" clearable></el-input>
        </el-form-item>
        <br>
        <el-form-item label="Remark:" prop="customerRemarks" v-if="isCustomer">
          <el-input type="textarea" :autosize="{ minRows: 3 }" :disabled="shipInfoDisabled"
            v-model="shipData.customerRemarks" clearable :style="{ width: '200%' }"></el-input>
        </el-form-item>
      </el-form>
      <ShipVettingUploadDocument class="mt-2" :componentName="'Ship'" :componentId="'shipDoc'"
        :uploadedFiles="shipFilesFromApi" :disabled="shipDocumentDisabled" @files-changed="updateShipFiles"
        @files-deleted="deleteShipFiles" @file-removed="removeRawFile" ref="uploadShipDoc" />

      <div class="information mt-4" v-if="!isCustomer">
        <div class="flex justify-between divider-line mb-1">
          <p class="">Inspection</p>
          <el-button size="mini" type="primary" plain @click="addInspection"
            v-if="(shipData.shipStatus == 4 || shipData.shipStatus == 2 || shipData.shipStatus == 6) && (userInfo.role == 13 || userInfo.role == 1)">Add
            Inspection</el-button>
        </div>
        <div v-for="(inspection, index) in inspections" :key="inspection.id || index" class="inspectionContainer">
          <div class="flex justify-between items-center mb-4" v-if="index != 0">
            <div class="divider-line" style="flex-grow: 1; margin-right: 10px;"></div>
            <el-button size="mini" type="danger" plain @click="removeInspection(index)" v-if="inspection.isNew">
              Remove
            </el-button>
          </div>
          <el-form ref="inspectionForm" size="mini" label-position="top" :model="inspection" :inline="false">
            <template v-if="index === 0">
              <div class="flex flex-row gap-4">
                <el-form-item label="SIRE Document Date" prop="inspectionDate">
                  <el-date-picker v-model="inspection.inspectionDate" placeholder="SIRE Document Date" type="date"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable
                    :disabled="inspectionDisabled(index, inspection.isNew)" />
                </el-form-item>

                <el-form-item label="Validity Date" prop="validityDate">
                  <el-date-picker v-model="shipData.validityDate" placeholder="Validity Date" type="date"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable disabled />
                </el-form-item>
              </div>
            </template>
            <el-form-item v-if="index === 0" label="UT Observation Date" prop="utObservationDate">
              <el-date-picker v-model="shipData.utObservationDate" placeholder="UT Observation Date" type="date"
                format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled="utDateDisabled" clearable />
            </el-form-item>
            <el-form-item label="Remarks">
              <el-input size="mini" v-model="inspection.inspectionRemarks" type="textarea" :autosize="{ minRows: 3 }"
                style="width: 50%" clearable :disabled="inspectionDisabled(index, inspection.isNew)" />
            </el-form-item>
          </el-form>
          <ShipVettingUploadDocument :componentName="'Inspector'" :componentId="'inspectorDoc-' + index"
            :disabled="inspectionDisabled(index, inspection.isNew)" :uploadedFiles="inspections[index].oldDocuments"
            @files-changed="updateInspectionFiles(index, $event)"
            @files-deleted="deleteInspectionFiles(index, $event)" />
        </div>
      </div>


    </div>
    <success-dialog v-on="$listeners" ref="successDialog" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ShipVettingUploadDocument from './upload.vue'
import { getShipVettingStatus } from "@/utils/constants";
import userInfo from "@/mixins/userInfo";
// import SuccessDialog from "./success-dialog.vue";
import SuccessDialog from "@/components/common/success-dialog.vue";
import {
  updateShipVettingRequestData,
  updateShipVettingRequestStatus,
  uploadShipVettingShipDocument,
  updateShipVettingInspection,
  createCustomerVetReq,
  getShipVettingHistoryByImo,
  updateShipInfo,
  updateCustomerDoc,
  addNewShipVettingRequest,
  updateShipVettingRequestInfo,
} from "@/services";
import { searchBarge } from '@/services/user';
import { has } from "lodash";

class Inspection {
  constructor() {
    this.id = null;
    this.oldDocuments = [];
    this.inspectionDate = null;
    this.inspectionRemarks = null;
    this.documents = [];
    this.deletedIds = [];
    this.isNew = true;
  }
}
export default {
  name: "ShipVettingInformation",
  components: { ShipVettingUploadDocument, SuccessDialog },
  props: {
    imo: {
      default: null,
    },
    shipName: {
      default: null,
    },
    requestData: {
      default: null,
    },
  },
  watch: {
    requestData(val) {
      this.getList();
    },
  },
  data() {
    return {
      shipData: {
        companyId: "",
        imo: "",
        shipName: "",
        buildDate: "",
        deadWeight: "",
        flag: "",
        loa: "",
        // utObservationDate: "",
        shipStatus: "",
        customerRemarks: "",
      },
      shipFiles: [],
      shipFilesFromApi: [],
      shipFilesDeleted: [],
      inspectionObj: {
        id: null,
        oldDocuments: [],
        inspectionDate: null,
        inspectionRemarks: "",
        documents: [],
        deletedIds: [],
        isNew: true,
      },
      inspections: [
      ],
      inspectionsFromApi: [],
      deletedFilesId: [],
      rid: "",
      pickerOptions: {
        disabledDate(date) {
          const currentYear = new Date().getFullYear();
          return date.getFullYear() > currentYear;
        }
      },
      isBargeOptionsLoading: true,
      bargeoptions: [],
      imoSearchText: "",
      rules: {
        imo: [
          { required: true, message: "  ", trigger: "blur" },
        ],
        shipName: [
          { required: true, message: "  ", trigger: "blur" },
        ],
        buildDate: [
          { required: true, message: "  ", trigger: "blur" },
        ],
        deadWeight: [
          { required: true, message: "  ", trigger: "blur" },
        ],
        flag: [
          { required: true, message: "  ", trigger: "blur" },
        ],
        loa: [
          { required: true, message: "  ", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "screenType"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },
    shipInfoDisabled() {
      const pageStatus = this.$route.query.pageStatus;
      const isLogistics = this.userInfo.role == 1;
      const isCustomer = this.userInfo.role == 4 || this.userInfo.role == 5;
      const isInspector = this.userInfo.role == 13;
      const requestStatus = isCustomer ? this.requestData.status : this.requestData.shipStatus;
      if (pageStatus == 2) {
        return false;
      }
      if (Number(this.requestData.id) !== Number(this.$route.query.id)) {
        return true;
      }
      if (isLogistics) {
        return false;
      }
      if (isCustomer && (requestStatus == 1 || requestStatus == 7 || requestStatus == 8)) {
        return false;
      }
      if ((isInspector || isLogistics) && (requestStatus == 2 || requestStatus == 4)) {
        return false;
      }
      return true;
    },
    imoDisabled() {
      const pageStatus = Number(this.$route.query.pageStatus) ?? 0;
      if (pageStatus == 2) {
        return false;
      }
      return true;
    },
    utDateDisabled() {
      const status = this.requestData.shipStatus;
      const isLog = this.userInfo.role == 1;
      const isInsp = this.userInfo.role == 13;
      // inspector OR logistics can edit utDate on 2 or 4
      if ((isInsp || isLog) && [2, 4, 6].includes(status)) {
        return false;
      }
      return true;
    },
    shipDocumentDisabled() {
      const pageStatus = this.$route.query.pageStatus;
      const isLogistics = this.userInfo.role == 1;
      const isCustomer = this.userInfo.role == 4 || this.userInfo.role == 5;

      const requestStatus = isCustomer ? this.requestData.status : this.requestData.shipStatus;
      if (pageStatus == 2) {
        return false;
      }
      if (Number(this.requestData.id) !== Number(this.$route.query.id)) {
        return true;
      }

      if (isLogistics) {
        return false;
      }

      if ((isCustomer) && (requestStatus == 1 || requestStatus == 7 || requestStatus == 8)) {
        return false;
      }
      return true;
    },
    inspectionDisabled() {
      return function (index, isNew) {
        if ((this.userInfo.role == 13 || this.userInfo.role == 1) && (this.requestData.shipStatus == 2 || this.requestData.shipStatus == 4 || this.requestData.shipStatus == 6)) {
          if (index == 0) {
            return false;
          }
          if (isNew) {
            return false
          }

          return true;
        }
        return true;
      };

    },
    isCustomer() {
      return this.userInfo.role == 4 || this.userInfo.role == 5;
    },
    isLogistics() {
      return this.userInfo.role == 1;
    },
    isInspector() {
      return this.userInfo.role == 13;
    },
    disableLogisticInspection() {
      return this.isLogistics && [7, 8].includes(this.shipData.shipStatus)
    }
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  methods: {
    inspectUploadDisabled(index, isNew) {
      if (this.disableLogisticInspection) {
        return true;
      }
      // otherwise fall back to your existing rules:
      return this.isLogistics
        ? this.shipDocumentDisabled
        : this.inspectionDisabled(index, isNew);
    },

    getList() {
      this.shipFiles = [];
      this.shipFilesFromApi = [];
      this.shipFilesDeleted = [];
      this.inspections = [new Inspection()];

      if (this.requestData && this.$route.query.pageStatus != 2) {
        this.shipData = { ...this.requestData };

        if (this.shipData && this.shipData.documents && this.shipData.documents.length > 0) {
          this.shipFilesFromApi = this.shipData.documents.map(doc => ({
            ...doc,
          }));
        }
        if (this.shipData && this.shipData.customerDocuments && this.shipData.customerDocuments.length > 0) {
          this.shipFilesFromApi = this.shipData.customerDocuments.map(doc => ({
            ...doc,
          }));
        }


        if (this.shipData && this.shipData.inspections && this.shipData.inspections.length > 0 && !(this.inspections.length === 1 && this.inspections[0].inspectionRemarks === "")) {
          const actualInspections = this.shipData.inspections.map(ins => ({
            id: ins.id,
            inspectionDate: ins.inspectionDate,
            inspectionRemarks: ins.inspectionRemarks,
            oldDocuments: ins.documents,
            documents: [],
            deletedIds: [],
            isNew: false,
          })).filter(ins => ins.inspectionRemarks.trim() !== "");
          this.inspections.push(...actualInspections);
        }
        this.inspections[0].inspectionDate = this.shipData.sireDocumentDate;
        this.inspections[0].inspectionRemarks = this.shipData.inspectorRemarks;
        this.inspections[0].oldDocuments = this.shipData.inspections.filter(ins => ins.inspectionRemarks.trim() === "")[0]?.documents
        this.inspections[0].isNew = false;
        this.inspections[0].id = this.shipData.inspections.filter(ins => ins.inspectionRemarks.trim() === "")[0]?.id
      }
    },

    onImoTyping(val) {
      this.imoSearchText = val;
    },

    async handleSearchBarge(query) {
      if (!query) {
        this.bargeoptions = [];
        return;
      }

      this.isBargeOptionsLoading = true;
      try {
        const res = await getShipVettingHistoryByImo(query);
        this.bargeoptions = res.data || [];
      } catch (e) {
        this.bargeoptions = [];
      } finally {
        this.isBargeOptionsLoading = false;
      }
    },

    handleSelectedIMO(selectedIMO) {
      const selectedBarge = this.bargeoptions.find(item => item.imo === selectedIMO);

      if (selectedBarge) {
        this.shipData.imo = selectedBarge.imo;
        this.shipData.shipName = selectedBarge.shipName || "";
        this.shipData.buildDate = selectedBarge.buildDate || "";
        this.shipData.deadWeight = selectedBarge.deadWeight || "";
        this.shipData.flag = selectedBarge.flag || "";
        this.shipData.loa = selectedBarge.loa || "";
      } else {
        // allow-create typed value (free text)
        this.shipData.imo = selectedIMO;
      }
    },

    updateShipFiles(files) {
      this.shipFiles = files;
    },

    deleteShipFiles(id) {
      if (id) {
        this.shipFilesDeleted.push(id);
      }
    },

    addInspection() {
      this.inspections.push(new Inspection());
    },

    removeInspection(index) {
      if (this.inspections[index]?.isNew) {
        this.inspections.splice(index, 1);
      }
    },

    updateInspectionFiles(index, files) {
      this.inspections[index].documents = files;
    },
    async handleFileDuplicated(file) {
      this.$refs.uploadShipDoc.duplicateFile(file);
    },

    deleteInspectionFiles(index, id) {
      if (id) {
        this.inspections[index].deletedIds.push(id);
      }
    },

    async updateRequest(params, callback) {
      const requestStatus = this.shipData.shipStatus;
      const isLogistics = this.userInfo.role == 1;
      const isCustomer = this.userInfo.role == 4 || this.userInfo.role == 5;
      const isInspector = this.userInfo.role == 13;
      const btnStatus = params.status;
      const skipStatusUpdate = params?.skipStatusUpdate ?? false;
      const logisticsRemarks = params.logisticsRemarks;
      const suspendedStartDate = params.suspendedStartDate;
      const suspendedEndDate = params.suspendedEndDate;
      const rejectRemarks = params.rejectRemarks ?? '';

      const data = {
        companyId: this.userInfo.companyId,
        imo: this.shipData.imo,
        shipName: this.shipData.shipName,
        buildDate: this.shipData.buildDate,
        deadWeight: this.shipData.deadWeight,
        flag: this.shipData.flag,
        loa: this.shipData.loa,
        utObservationDate: this.shipData.utObservationDate,
        customerRemarks: this.shipData.customerRemarks,
      };
      data.deadWeight = data.deadWeight === "" ? null : parseFloat(data.deadWeight);
      if (!data.imo) {
        this.$message.error("IMO number required");
        return;
      }

      if (isInspector || isLogistics) {
        data.sireDocumentDate = this.inspections[0].inspectionDate;
        data.inspectorRemarks = this.inspections[0].inspectionRemarks;

        if (requestStatus == 2) {
          if (data.inspectorRemarks == null || data.inspectorRemarks.trim() == "") {
            this.$message.error("Inspection Remarks required");
            return;
          }
        }
      }

      try {
        let valid = false;
        try {
          valid = await this.$refs.shipInfoForm.validate();
        } catch (e) {
          valid = false;
        }

        if (!valid) {
          this.$message.error("Please fill in the required fields");
          return;
        }

        if (this.$route.query.pageStatus == 2) {
          if (isLogistics) {
            delete data.companyId;
            delete data.customerRemarks;

            data.shipStatus = btnStatus;
            if (btnStatus == 8) {
              data.remarks = logisticsRemarks
            }
            if (btnStatus == 10) {
              data.suspendedStart = suspendedStartDate
              data.suspendedEnd = suspendedEndDate
            }
            const res = await addNewShipVettingRequest(data, this.shipFiles);
            if (res.code === 200) {
              this.$refs.successDialog.open();
              this.$refs.successDialog.message = "New ship vetting request created";
              this.$refs.successDialog.shipVettingId = res.data.requestId;
            }
          }

          if (isCustomer) {
            const customerVettingReq = {
              ...data
            };

            const formData = new FormData();
            formData.append("customerVetting", JSON.stringify(customerVettingReq));

            this.shipFiles.forEach((file) => {
              formData.append("files", file);
            });

            await createCustomerVetReq(formData).then((res) => {
              if (res.code === 200) {
                const idMatch = res.msg.match(/ID:\s*(\d+)/);
                const id = idMatch ? idMatch[1] : null;

                this.$refs.successDialog.open();
                this.$refs.successDialog.message = "New ship vetting request created";
                this.$refs.successDialog.shipVettingId = id;
                this.$refs.successDialog.imo = this.shipData.imo;
              }
            })
          }
          return;
        }

        // Customer Update
        if (isCustomer) {
          delete data.companyId;
          delete data.imo;

          const res1 = await updateShipInfo(this.shipData.id, data);
          if (res1.code === 200) {
            this.$message.success("Request detail updated");
          }

          if (this.shipFiles.length !== 0 || this.shipFilesDeleted.length !== 0) {
            const res2 = await updateCustomerDoc(
              this.shipData.id,
              this.shipFiles,
              this.shipFilesDeleted
            );
            if (res2.code === 200) {
              this.$message.success("Ship Document uploaded");
            }
          }
        }

        if (isInspector || isLogistics) {
          // the submitted inspection set cannot be modified
          this.inspections = this.inspections.filter((inspection, index) => {
            return index === 0 || inspection.id == null;
          });

          // the first set can be modified
          if (this.inspections[0].deletedIds.length == 0 && this.inspections[0].documents.length == 0) {
            this.inspections.shift();
          } else {
            this.inspections[0].inspectionDate = null;
            this.inspections[0].inspectionRemarks = null;
            this.inspections[0].isNew = true;
          }

          if (isInspector) {
            const params = { shipStatus: btnStatus, };
            if (btnStatus == 13) {
              params.shipStatus = 7;
              const res3 = await updateShipVettingRequestStatus(
                this.$route.query.id,
                params
              );
              if (res3.code === 200) this.$message.success("Status updated");
            }
            const res1 = await updateShipVettingRequestData(this.shipData.id, data);
            if (res1.code === 200 && btnStatus === 1) {
              this.$message.success("Request detail updated");
            }

          }

          if (isLogistics || isInspector) {
            for (const inspection of this.inspections) {
              if (!inspection.isNew) continue;
              if (btnStatus == 11) {
                const res2 = await updateShipVettingInspection(this.shipData.id, inspection, 2);
                if (res2.code === 200) {
                  this.$message.success("Inspection detail updated");
                }
              } else {
                const res2 = await updateShipVettingInspection(this.shipData.id, inspection);
                if (res2.code === 200) {
                  this.$message.success("Inspection detail updated");
                }
              }

            }
          }
          if (isLogistics) {
            const res1 = await updateShipVettingRequestData(this.shipData.id, data);
            if (res1.code === 200 && btnStatus === 1) {
              this.$message.success("Request detail updated");
            }

            if (this.shipFiles.length !== 0 || this.shipFilesDeleted.length !== 0) {
              const res2 = await uploadShipVettingShipDocument(
                this.shipData.id,
                this.shipFiles,
                this.shipFilesDeleted
              );
              if (res2.code === 200) {
                this.$message.success("Ship Document uploaded");
              }
            }

            const params = { shipStatus: btnStatus, };
            if (btnStatus == 8) {
              params.remarks = logisticsRemarks;
            }
            if (btnStatus == 10) {
              params.suspendedStart = suspendedStartDate
              params.suspendedEnd = suspendedEndDate
            }

            if (btnStatus == 11) {
              data.shipStatus = 2;
              params.shipStatus = 2;
            }
            if (btnStatus == 12 || btnStatus == 13) {
              data.shipStatus = 7;
              params.shipStatus = 7;
            }

            if (btnStatus == 5) {
              params.shipStatus = 5
              params.rejectRemarks = rejectRemarks
            }

            const hasNewInspection = this.inspections.some((inspection) => inspection.isNew);
            if (skipStatusUpdate == false) {
              const res3 = await updateShipVettingRequestStatus(
                this.$route.query.id,
                // { shipStatus: btnStatus }
                params
              );
              if (res3.code === 200) this.$message.success("Request status updated");
            }
          }
        }
      } catch (error) {
        console.error("updateRequest - Error:", error);
      } finally {
        this.$emit("get-list");
        if (typeof callback === "function") callback();
      }
    },

    redirectToUpdatedPage(id) {
      this.$router.replace({
        path: "/ship-vetting/index",
        query: {
          id: id,
          pageStatus: 1,
        },
      });
      sessionStorage.setItem("pageStatus", 1);
      this.$router.go(0);
      return;
    },

    formatCompleteTime(row, column, cellValue) {
      if (!cellValue) return '';
      return cellValue.replace('T', ' ');
    },

    removeRawFile(rawFile) {
      this.shipFiles = this.shipFiles.filter((file) => file.originalFileName !== rawFile.originalFileName);
    },

    async saveRequestInfoOnly() {
      const isLogistics = this.userInfo.role == 1 || this.userInfo.role == "1";
      const isInspector = this.userInfo.role == 13 || this.userInfo.role == "13";

      if (!isLogistics && !isInspector) {
        this.$message.warning("You are not allowed to save this info");
        return;
      }

      if (!this.shipData?.id) {
        this.$message.error("Missing request id");
        return;
      }

      if (!this.shipData.imo) {
        this.$message.error("IMO number required");
        return;
      }

      const body = {
        imo: this.shipData.imo,
        shipName: this.shipData.shipName,
        buildDate: this.shipData.buildDate,
        flag: this.shipData.flag,
        deadWeight: this.shipData.deadWeight === "" ? null : Number(this.shipData.deadWeight),
        loa: this.shipData.loa,
        utObservationDate: this.shipData.utObservationDate,
        sireDocumentDate: this.inspections?.[0]?.inspectionDate ?? null,
        inspectorRemarks: this.inspections?.[0]?.inspectionRemarks ?? null,
      };

      try {
        const res = await updateShipVettingRequestInfo(this.shipData.id, body);
        if (res?.code !== 200) {
          this.$message.error("Save failed");
          return;
        }

        if (this.shipFiles.length !== 0 || this.shipFilesDeleted.length !== 0) {
          const res2 = await uploadShipVettingShipDocument(
            this.shipData.id,
            this.shipFiles,
            this.shipFilesDeleted
          );
          if (res2?.code === 200) {
            this.$message.success("Saved Successfully");
          } else {
            this.$message.warning("Info saved, but ship document upload failed");
          }
        } else {
          this.$message.success("Saved");
        }
      } catch (e) {
        console.error("saveRequestInfoOnly error", e);
        this.$message.error("Save failed");
      } finally {
        this.$emit("get-list");
      }
    },

    applyOcrData(payload) {
      // payload might be { code, data } or just the data object
      const data = payload?.data ?? payload ?? {};

      const pick = (obj, keys) => {
        for (const k of keys) {
          const v = obj?.[k];
          if (v !== undefined && v !== null && String(v).trim() !== "") return v;
        }
        return null;
      };

      const normalizeDate = (v) => {
        if (!v) return v;

        let s = String(v).trim();
        if (!s) return s;

        // remove time
        if (s.includes("T")) s = s.split("T")[0];

        // if OCR returns "20/3/2023, Yangfan shipyard" take only the date part
        s = s.split(",")[0].trim();

        // already correct
        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;

        // yyyy/m/d or yyyy-m-d
        let m = s.match(/^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})$/);
        if (m) {
          return `${m[1]}-${String(m[2]).padStart(2, "0")}-${String(m[3]).padStart(2, "0")}`;
        }

        // d/m/yyyy or dd/mm/yyyy
        m = s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})$/);
        if (m) {
          let y = String(m[3]);
          if (y.length === 2) y = `20${y}`;
          return `${y}-${String(m[2]).padStart(2, "0")}-${String(m[1]).padStart(2, "0")}`;
        }

        // "Nov 11, 2025" style
        const parsed = Date.parse(s);
        if (!Number.isNaN(parsed)) {
          const d = new Date(parsed);
          const yyyy = d.getFullYear();
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const dd = String(d.getDate()).padStart(2, "0");
          return `${yyyy}-${mm}-${dd}`;
        }

        return s;
      };


      const newImo = pick(data, ["imo", "imoNo", "imoNumber", "imono"]);
      const newShipName = pick(data, ["shipName", "name", "vesselName", "vessel"]);
      const newBuildDate = pick(data, ["buildDate", "builtDate", "built_date"]);
      const newDeadWeight = pick(data, ["deadWeight", "dwt", "dead_weight"]);
      const newFlag = pick(data, ["flag", "shipFlag"]);
      const newLoa = pick(data, ["loa", "lengthOverall", "length_overall"]);

      if (newImo != null) this.shipData.imo = String(newImo);
      if (newShipName != null) this.shipData.shipName = String(newShipName);
      if (newBuildDate != null) this.shipData.buildDate = normalizeDate(String(newBuildDate));
      if (newDeadWeight != null) this.shipData.deadWeight = newDeadWeight;
      if (newFlag != null) this.shipData.flag = String(newFlag);
      if (newLoa != null) this.shipData.loa = newLoa;

      // force UI update if needed
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped lang="scss">
.ship-info {
  height: 100%;
}

::v-deep .el-form--label-top .el-form-item__label {
  padding: 0;
}

::v-deep .el-form-item--mini .el-form-item__label {
  line-height: 20px;
}

::v-deep .el-form-item--mini {
  margin-bottom: 0px;
}

::v-deep .el-form-item {
  margin-bottom: 10px;
}

.information {
  // font-size: 12px;

  .divider-line {
    padding-bottom: 5px;
    border-bottom: 2px solid #e5e7ed;
  }

  .title {
    // color: #4c565c;
    // margin-left: 9px;
    // font-size: 14px;
  }
}

.content {
  font-size: 12px;
  color: #606266;
}

.docTitle {
  color: #606266;
  font-size: 14px;
}

::v-deep .el-tabs--card {
  height: calc(100vh - 110px);
}

::v-deep .el-tab-pane {
  height: calc(100vh - 110px);
  overflow-y: auto;
}

::v-deep .el-tab__content {
  height: calc(100vh - 110px);
  overflow-y: auto;
}

.inspectionContainer {
  // border-radius: 10px;
  // padding-bottom: 10px;
  // border-bottom: 1px solid #e5e7ed;
}

::v-deep.bargeNameinput {
  width: 100%;

  .el-input__inner {
    color: #2e5efd !important;
  }
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  color: #4e565c !important;
}
</style>